import FieldDefs from './OwnerFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.owner_subdomains.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'name',
                    direction: 'asc'
                }
            ],
            moreParams: {},
            viewMode: 0,
            options: [
                {label: this.$t('lang.report.owner_subdomains.organic'), value: 0},
                {label: this.$t('lang.report.owner_subdomains.context'), value: 1},
            ]
        }
    },
    mounted () {
        this.initFields();
    },
    computed: {
        self() {
            return this;
        }
    },
    methods: {
        initFields () {
            let self = this;
            self.fields.forEach((f) =>{
                if(f.hasOwnProperty('visibleRule')){
                    f.visible = eval(f.visibleRule);
                }
            });
            this.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
        }
    },
    watch: {
        viewMode: function(val){
            this.initFields();
        }
    }

}
